"use client";

import { useState, useEffect, useMemo } from "react";
import logoAlcaldia from "../assets/logooficial.png";

function CDPViewer({
  isOpen = true,
  onClose,
  // ✅ soporta ambos nombres para no romper nada
  cdpData,
  formData,
  contractData, // (opcional)
  userRole,     // (opcional)
}) {
  // ✅ toma el que venga
  const incoming = cdpData ?? formData ?? null;

  const normalized = useMemo(() => {
    if (!incoming) return null;

    // Caso: { ok: true, data: [...] }
    if (
      typeof incoming === "object" &&
      !Array.isArray(incoming) &&
      Array.isArray(incoming.data)
    ) {
      return incoming.data[0] ?? null;
    }

    // Caso: [... ]
    if (Array.isArray(incoming)) {
      return incoming[0] ?? null;
    }

    // Caso: {...}
    return incoming;
  }, [incoming]);

  const [localForm, setLocalForm] = useState({
    fecha: "",
    dependencia: "",
    vigenciaFutura: "NO",
    documentoVigenciaFutura: "",
    tipoGasto: "",
    codigoBancop: "",
    objetoIndicador: "",
    centroCostos: "",
    valorNumerico: "",
    valorLetras: "",
    solicitante: "",
    cargoSolicitante: "",
    firmaUrl: "",
    firmaAlcaldeUrl: "",
    rubrosData: [],

    estado_cdp: "Pendiente",
    fechaAprobacion: "",
    numeroCdp: "",
    motivoRechazo: "",
  });

  useEffect(() => {
    if (!normalized) return;

    const rawRubros =
      normalized.rubrosData ??
      normalized.rubros_json ??
      normalized.rubros ??
      normalized.rubrosdata ??
      normalized.rubros_data ??
      null;

    let rubrosParsed = [];

    if (Array.isArray(rawRubros)) {
      rubrosParsed = rawRubros;
    } else if (typeof rawRubros === "string" && rawRubros.trim() !== "") {
      try {
        const parsed = JSON.parse(rawRubros);
        rubrosParsed = Array.isArray(parsed) ? parsed : [];
      } catch {
        rubrosParsed = [];
      }
    } else {
      rubrosParsed = [];
    }

    rubrosParsed = rubrosParsed.map((r) => ({
      resumido: r?.resumido ?? r?.RESUMIDO ?? "",
      componenteInversion:
        r?.componenteInversion ??
        r?.componente_inversion ??
        r?.componenteInversión ??
        r?.COMPONENTE ??
        "",
      valor: r?.valor ?? r?.VALOR ?? 0,
    }));

    const estado =
      normalized.estado_cdp ||
      normalized.response_status ||
      normalized.status_cdp ||
      normalized.estado ||
      "Pendiente";

    const fechaAprob =
      normalized.fechaAprobacion ||
      normalized.responded_at ||
      normalized.fecha_documento ||
      "";

    const numero =
      normalized.numeroCdp ||
      normalized.numero_documento ||
      normalized.numero_cdp ||
      "";

    setLocalForm({
      fecha: normalized.fecha || "",
      dependencia: normalized.dependencia || "",
      vigenciaFutura: normalized.vigenciaFutura || normalized.vigencia_futura || "NO",
      documentoVigenciaFutura:
        normalized.documentoVigenciaFutura || normalized.documento_vigencia_futura || "",
      tipoGasto: normalized.tipoGasto || normalized.tipo_gasto || "",
      codigoBancop: normalized.codigoBancop || normalized.codigo_bancop || "",
      objetoIndicador: normalized.objetoIndicador || normalized.objeto_indicador || "",
      centroCostos: normalized.centroCostos || normalized.centro_costos || "",
      valorNumerico: normalized.valorNumerico || normalized.valor_numerico || "",
      valorLetras: normalized.valorLetras || normalized.valor_letras || "",
      solicitante: normalized.solicitante || "",
      cargoSolicitante: normalized.cargoSolicitante || normalized.cargo_solicitante || "",
      firmaUrl: normalized.firmaUrl || normalized.firma_url || "",
      firmaAlcaldeUrl: normalized.firmaAlcaldeUrl || normalized.firma_alcalde_url || "",
      rubrosData: rubrosParsed,

      estado_cdp: estado,
      fechaAprobacion: fechaAprob,
      numeroCdp: numero,
      motivoRechazo: normalized.motivoRechazo || normalized.motivo_rechazo || "",
    });
  }, [normalized]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("es-CO");
  };

  const rubros = Array.isArray(localForm.rubrosData) ? localForm.rubrosData : [];

  if (!isOpen) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #1e3a8a, #1e40af)",
        padding: "1rem",
        boxSizing: "border-box",
      }}
    >
      <div
        className="container"
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          maxHeight: "90vh",
          overflowY: "auto",
          background: "white",
          borderRadius: "0.5rem",
        }}
      >
        {/* Header */}
        <div className="form-header">
          <div
            style={{
              padding: "5px",
              borderRadius: "4px",
              display: "inline-block",
              backgroundColor: "transparent",
            }}
          >
            <img src={logoAlcaldia || "/placeholder.svg"} alt="Logo Alcaldía" className="logo" />
          </div>

          <div>
            <h3>SOLICITUD DE</h3>
            <h3>DISPONIBILIDAD PRESUPUESTAL</h3>
          </div>

          <div className="form-id">
            <span style={{ display: "block" }}>Código: A-CBS-F-013</span>
            <span style={{ display: "block" }}>Versión: 10</span>
            <span style={{ display: "block" }}>Fecha Actualización: 13-01-2025</span>
          </div>
        </div>

        {/* Contenido SOLO LECTURA */}
        <div className="form-content">
          <table className="form-table">
            <tbody>
              <tr>
                <th style={{ width: "200px" }}>FECHA:</th>
                <td>
                  <input
                    type="text"
                    value={formatDate(localForm.fecha)}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>DEPENDENCIA:</th>
                <td>
                  <input
                    type="text"
                    value={localForm.dependencia}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>VIGENCIA FUTURA:</th>
                <td>
                  <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="vigenciaFutura"
                        value="SI"
                        checked={localForm.vigenciaFutura === "SI"}
                        disabled
                      />
                      SI
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="vigenciaFutura"
                        value="NO"
                        checked={localForm.vigenciaFutura === "NO"}
                        disabled
                      />
                      NO
                    </label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>TIPO DE GASTO:</th>
                <td>
                  <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="tipoGasto"
                        value="Inversión"
                        checked={localForm.tipoGasto === "Inversión"}
                        disabled
                      />
                      INVERSIÓN
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="tipoGasto"
                        value="Funcionamiento"
                        checked={localForm.tipoGasto === "Funcionamiento"}
                        disabled
                      />
                      FUNCIONAMIENTO
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        type="radio"
                        name="tipoGasto"
                        value="Servicio de la Deuda"
                        checked={localForm.tipoGasto === "Servicio de la Deuda"}
                        disabled
                      />
                      DEUDA PÚBLICA
                    </label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>CÓDIGO DEL BANCOP:</th>
                <td>
                  <input
                    type="text"
                    value={localForm.codigoBancop}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>OBJETO CON INDICADOR DEL PLAN DE DESARROLLO:</th>
                <td>
                  <textarea
                    value={localForm.objetoIndicador}
                    readOnly
                    rows={4}
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>RUBRO PRESUPUESTAL:</th>
                <td>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", border: "1px solid #ccc", borderCollapse: "collapse" }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f5f5f5" }}>
                          <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", minWidth: "120px" }}>
                            RESUMIDO
                          </th>
                          <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", minWidth: "180px" }}>
                            COMPONENTE DE INVERSIÓN
                          </th>
                          <th style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", minWidth: "100px" }}>
                            VALOR
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {rubros.length > 0 ? (
                          rubros.map((rubro, index) => (
                            <tr key={index}>
                              <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                                <input
                                  type="text"
                                  value={rubro.resumido || ""}
                                  readOnly
                                  style={{ width: "100%", border: "none", background: "#f3f4f6", fontSize: "12px", cursor: "not-allowed" }}
                                />
                              </td>
                              <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                                <input
                                  type="text"
                                  value={rubro.componenteInversion || ""}
                                  readOnly
                                  style={{
                                    width: "100%",
                                    padding: "4px",
                                    fontSize: "11px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    backgroundColor: "#f3f4f6",
                                    cursor: "not-allowed",
                                  }}
                                />
                              </td>
                              <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "right" }}>
                                <input
                                  type="text"
                                  value={Number(rubro.valor || 0).toLocaleString("es-CO")}
                                  readOnly
                                  style={{
                                    width: "100%",
                                    border: "none",
                                    background: "#f3f4f6",
                                    textAlign: "right",
                                    fontSize: "12px",
                                    cursor: "not-allowed",
                                  }}
                                />
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" style={{ border: "1px solid #ccc", padding: "20px", textAlign: "center", color: "#666" }}>
                              No hay rubros disponibles
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>

              <tr>
                <th>CENTRO DE COSTOS:</th>
                <td>
                  <input
                    type="text"
                    value={localForm.centroCostos}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>VALOR: (En letras)</th>
                <td>
                  <textarea
                    value={localForm.valorLetras}
                    readOnly
                    rows={2}
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>VALOR: (Numérico)</th>
                <td>
                  <input
                    type="text"
                    value={Number(localForm.valorNumerico || 0).toLocaleString("es-CO")}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>ESTADO CDP:</th>
                <td>
                  <input
                    type="text"
                    value={localForm.estado_cdp || "Pendiente"}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              {String(localForm.estado_cdp || "").toLowerCase() === "aprobado" && (
                <>
                  <tr>
                    <th>FECHA DE APROBACIÓN:</th>
                    <td>
                      <input
                        type="text"
                        value={formatDate(localForm.fechaAprobacion || "")}
                        readOnly
                        className="form-control"
                        style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>NÚMERO CDP:</th>
                    <td>
                      <input
                        type="text"
                        value={localForm.numeroCdp || ""}
                        readOnly
                        className="form-control"
                        style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                      />
                    </td>
                  </tr>
                </>
              )}

              {String(localForm.estado_cdp || "").toLowerCase() === "negado" && (
                <tr>
                  <th>MOTIVO RECHAZO:</th>
                  <td>
                    <textarea
                      value={localForm.motivoRechazo || ""}
                      readOnly
                      rows={3}
                      className="form-control"
                      style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                    />
                  </td>
                </tr>
              )}

              <tr>
                <th>SOLICITANTE:</th>
                <td>
                  <input
                    type="text"
                    value={localForm.solicitante}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              <tr>
                <th>CARGO SOLICITANTE:</th>
                <td>
                  <input
                    type="text"
                    value={localForm.cargoSolicitante}
                    readOnly
                    className="form-control"
                    style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed" }}
                  />
                </td>
              </tr>

              {localForm.firmaUrl && (
                <tr>
                  <th>FIRMA SOLICITANTE:</th>
                  <td>
                    <img
                      src={localForm.firmaUrl || "/placeholder.svg"}
                      alt="Firma del solicitante"
                      style={{ maxWidth: "200px", maxHeight: "100px" }}
                    />
                  </td>
                </tr>
              )}

              {localForm.firmaAlcaldeUrl && (
                <tr>
                  <th>FIRMA ALCALDE:</th>
                  <td>
                    <img
                      src={localForm.firmaAlcaldeUrl}
                      alt="Firma del alcalde"
                      style={{ maxWidth: "200px", maxHeight: "100px" }}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="form-actions" style={{ display: "flex", justifyContent: "flex-end", padding: "1rem", gap: "0.5rem" }}>
          <button onClick={onClose} className="btn btn-secondary">
            Cerrar
          </button>
        </div>

        <div className="form-footer">
          <p>Página 1 de 1 • Oficina Jurídica • SOLO LECTURA</p>
        </div>
      </div>
    </div>
  );
}

export default CDPViewer;
